'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var classes = require('classnames');
var useTabs = require('./useTabs.js');
var Tabs_module = require('../Tabs.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classes__default = /*#__PURE__*/_interopDefaultLegacy(classes);

var Tab = function (_a) {
    var tabItem = _a.tabItem, index = _a.index, onKeyup = _a.onKeyup, setRefByIndex = _a.setRefByIndex;
    var _b = useTabs.useTabs(), setActiveTab = _b.setActiveTab, activeTab = _b.activeTab;
    var ref = React.useRef(null);
    React.useEffect(function () {
        setRefByIndex(ref, index);
    }, [setRefByIndex, index]);
    return (jsxRuntime.jsxs("button", _tslib.__assign({ ref: ref, id: "tab-".concat(tabItem.label), type: "button", className: classes__default["default"](Tabs_module["default"].tab, activeTab === tabItem.label && [Tabs_module["default"].active]), onClick: function () { return setActiveTab(tabItem.label); }, onKeyUp: function (event) { return onKeyup(event, tabItem); }, role: "tab", tabIndex: activeTab === tabItem.label ? 0 : -1, "aria-selected": activeTab === tabItem.label && true, "aria-controls": "panel-".concat(tabItem.label) }, { children: [tabItem.children, tabItem.unreadCount !== 0 && tabItem.unreadCount && (jsxRuntime.jsxs("span", _tslib.__assign({ className: Tabs_module["default"].notification, "aria-label": "".concat(tabItem.unreadCount, " new") }, { children: ["(", tabItem.unreadCount, ")"] })))] })));
};

exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map
